var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_c('img',{attrs:{"src":_vm.titleButterflyImg}}),_c('div',{staticClass:"article-category"},[_c('span',[_vm._v(_vm._s(_vm.wzzl.title))])]),_c('img',{attrs:{"src":_vm.titleButterflyImg}})])])}
var staticRenderFns = []

export { render, staticRenderFns }